const TokenKey = "Zmndm-User-Token";

export function getToken() {
  //return window.localStorage.getItem(TokenKey)
  return localStorage.getExpire(TokenKey);
}
export function setToken(token) {
  //return window.localStorage.setItem(TokenKey, token)
  return localStorage.setExpire(TokenKey, token, Glob.tokenExpire * 1000);
}
export function removeToken() {
  return window.localStorage.removeItem(TokenKey);
}

Storage.prototype.setExpire = (key, value, expire) => {
  let obj = {
    data: value,
    time: Date.now(),
    expire: expire
  };
  localStorage.setItem(key, JSON.stringify(obj));
}

Storage.prototype.getExpire = key => {
  let val = localStorage.getItem(key);
  if (!val) {
    return val;
  }
  val = JSON.parse(val);
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key);
    return null;
  }
  //延长token有效期
  val.time = Date.now();
  localStorage.setItem(key, JSON.stringify(val));
  return val.data;
}


// WEBPACK FOOTER //
// ./src/utils/token.js